import FormFooter from 'components/organisms/Form/FormFooter/FormFooter'
import { Form, Formik } from 'formik'
import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { asyncMethod } from 'redux/actions'
import * as Yup from 'yup'
import * as FormConst from '../../../../constants/FormConst'
import RouteConst from '../../../../constants/RouteConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import * as actionTypes from '../../../../redux/actionTypes'
import RateplansService from '../../../../services/RateplansService'
import RoomTypesService from '../../../../services/RoomTypesService'
import {addDaysToDate, addYearsToDate, getCurrentDate, getDateFromDateString, getDateStringFromDate, getGapsInDateRanges, groupBy, isArrayNotEmpty, isObjectEmpty, isCompletedHotelInfoHistory, multipleDateRangeOverlaps, searchFirstObjectInList, searchObjectList, sortObjectByKeys, sortObjectList} from '../../../../utilities/JSUtil'
import { getSessionItem } from '../../../../utilities/SessionHelper'
import Button from '../../../atoms/Button/Button'
import TextInput from '../../../atoms/form/TextInput/TextInput'
import ToggleSwitch from '../../../atoms/form/ToggleSwitch/ToggleSwitch'
import FormModal from '../../../organisms/FormModal/FormModal'
import withFormLayout from '../WithFormLayout'
import './RackRateplan.scss'

export class RackRateplan extends Component {

    constructor(props) {
        super(props)

        const hotelCode = getSessionItem(SessionConst.HOTEL_CODE)
        const hotelInfo = getSessionItem(SessionConst.HOTEL_INFO)
        const hotelInfoCompletedHistory = getSessionItem(SessionConst.HOTEL_INFO_COMPLETED_HISTORY)

        if (!hotelCode || !hotelInfo) {
            this.props.history.push(RouteConst.ROUTE_HOME_PAGE)
        }

        const isLinkedRateplanConfig =
            hotelInfo.ratePlanConfigurationType === FormConst.RATE_PLAN_CONFIGURATION_TYPE_LINKED_VALUE
        // Will also consider linked rate plans as multi tier, to display linked rate plans as tiers.
        // Doesn't impact outgoing payloads. This is just a flag within this screen
        const isMultiTier = !!hotelInfo.useLosTiers || isLinkedRateplanConfig
        this.state = {
            hotelCode: hotelCode,
            hotelInfo: hotelInfo,
            hotelText: [],
            hotelCurrency: getSessionItem(SessionConst.HOTEL_CURRENCY),
            errorMessage: undefined,
            isLoading: true,
            loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
            initialValues: this.initialValues,
            isEdit: true,
            useLosTiers: hotelInfo.useLosTiers,
            isMultiTier: isMultiTier,
            isLinkedRateplanConfig: isLinkedRateplanConfig,
            tierLabels: isMultiTier ? (isLinkedRateplanConfig ? this.linkedConfigLabels : this.multiTierLabels) : this.singleTierLabels,
            hotelInfoCompletedHistory: hotelInfoCompletedHistory
        }
    }

    daysOfWeek = [
        FormConst.FIELD_MONDAY,
        FormConst.FIELD_TUESDAY,
        FormConst.FIELD_WEDNESDAY,
        FormConst.FIELD_THURSDAY,
        FormConst.FIELD_FRIDAY,
        FormConst.FIELD_SATURDAY,
        FormConst.FIELD_SUNDAY
    ]
    daysOfWeekLabels = [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday']

    singleTierLabels = ['tier1']
    multiTierLabels = ['tier1', 'tier2', 'tier3', 'tier4']
    linkedConfigLabels = ['tier1', 'sbase1', 'sbase2', 'sbase3', 'sbase4']

    tierDisplayLabels = {
        tier1: 'Tier 1',
        tier2: 'Tier 2',
        tier3: 'Tier 3',
        tier4: 'Tier 4',
        sbase1: 'SBASE 1',
        sbase2: 'SBASE 2',
        sbase3: 'SBASE 3',
        sbase4: 'SBASE 4',
    }

    tierValues = {
        tier1: FormConst.TIER_1,
        tier2: FormConst.TIER_2,
        tier3: FormConst.TIER_3,
        tier4: FormConst.TIER_4
    }

    dayOfTheWeekConstantAllTrue = {
        [FormConst.FIELD_MONDAY]: true,
        [FormConst.FIELD_TUESDAY]: true,
        [FormConst.FIELD_WEDNESDAY]: true,
        [FormConst.FIELD_THURSDAY]: true,
        [FormConst.FIELD_FRIDAY]: true,
        [FormConst.FIELD_SATURDAY]: true,
        [FormConst.FIELD_SUNDAY]: true
    }

    dayOfTheWeekConstantAllFalse = {
        [FormConst.FIELD_MONDAY]: false,
        [FormConst.FIELD_TUESDAY]: false,
        [FormConst.FIELD_WEDNESDAY]: false,
        [FormConst.FIELD_THURSDAY]: false,
        [FormConst.FIELD_FRIDAY]: false,
        [FormConst.FIELD_SATURDAY]: false,
        [FormConst.FIELD_SUNDAY]: false
    }

    dayOfTheWeekRates = {
        [FormConst.FIELD_MONDAY]: {
            [FormConst.FIELD_1P]: 0.00,
            [FormConst.FIELD_2P]: 0.00
        },
        [FormConst.FIELD_TUESDAY]: {
            [FormConst.FIELD_1P]: 0.00,
            [FormConst.FIELD_2P]: 0.00
        },
        [FormConst.FIELD_WEDNESDAY]: {
            [FormConst.FIELD_1P]: 0.00,
            [FormConst.FIELD_2P]: 0.00
        },
        [FormConst.FIELD_THURSDAY]: {
            [FormConst.FIELD_1P]: 0.00,
            [FormConst.FIELD_2P]: 0.00
        },
        [FormConst.FIELD_FRIDAY]: {
            [FormConst.FIELD_1P]: 0.00,
            [FormConst.FIELD_2P]: 0.00
        },
        [FormConst.FIELD_SATURDAY]: {
            [FormConst.FIELD_1P]: 0.00,
            [FormConst.FIELD_2P]: 0.00
        },
        [FormConst.FIELD_SUNDAY]: {
            [FormConst.FIELD_1P]: 0.00,
            [FormConst.FIELD_2P]: 0.00
        },
    }

    initialValues = {
        isSameRate1P2P: true,
        isSameRateDOW: false,
        isSameRateAllRoomTypes: true,
        isRateSeasonal: false,
        showSeasons: false,
        showMultipleTiers: false,
        seasons: [{
            startDate: '',
            endDate: '',
            tier1: {
                roomTypeGroups: [
                    {
                        roomTypes: [],
                        rates: { ...this.dayOfTheWeekRates }
                    }
                ]
            },
            tier2: {},
            tier3: {},
            tier4: {},
            sbase1: {},
            sbase2: {},
            sbase3: {},
            sbase4: {}
        }],
        allowSeasons: false
    }

    rateAmountSchema = Yup.number().required(FormConst.VALIDATION_ERROR_REQUIRED).test(
        "maxDecimalPlaces",
        "Max 2 decimal places allowed",
        (number) => FormConst.PATTERN_MAX_TWO_DECIMALS.test(number)
      ).min(FormConst.MIN_RACK_RATES_VALUE, 'Value must be greater than 20')

    roomTypeGroupsSchema = Yup.array().of(
        Yup.object().shape({
            roomTypes: Yup.array().of(
                Yup.object().shape({
                    code: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
                    isChecked: Yup.boolean().required(FormConst.VALIDATION_ERROR_REQUIRED)
                })
            ),
            rates: Yup.object().shape({
                [FormConst.FIELD_MONDAY]: Yup.object().shape({
                    [FormConst.FIELD_1P]: this.rateAmountSchema,
                    [FormConst.FIELD_2P]: this.rateAmountSchema
                }),
                [FormConst.FIELD_TUESDAY]: Yup.object().shape({
                    [FormConst.FIELD_1P]: this.rateAmountSchema,
                    [FormConst.FIELD_2P]: this.rateAmountSchema
                }),
                [FormConst.FIELD_WEDNESDAY]: Yup.object().shape({
                    [FormConst.FIELD_1P]: this.rateAmountSchema,
                    [FormConst.FIELD_2P]: this.rateAmountSchema
                }),
                [FormConst.FIELD_THURSDAY]: Yup.object().shape({
                    [FormConst.FIELD_1P]: this.rateAmountSchema,
                    [FormConst.FIELD_2P]: this.rateAmountSchema
                }),
                [FormConst.FIELD_FRIDAY]: Yup.object().shape({
                    [FormConst.FIELD_1P]: this.rateAmountSchema,
                    [FormConst.FIELD_2P]: this.rateAmountSchema
                }),
                [FormConst.FIELD_SATURDAY]: Yup.object().shape({
                    [FormConst.FIELD_1P]: this.rateAmountSchema,
                    [FormConst.FIELD_2P]: this.rateAmountSchema
                }),
                [FormConst.FIELD_SUNDAY]: Yup.object().shape({
                    [FormConst.FIELD_1P]: this.rateAmountSchema,
                    [FormConst.FIELD_2P]: this.rateAmountSchema
                }),
            })
        })
    )

    validationSchema = Yup.object().shape({
        seasons: Yup.array().of(
            Yup.object().shape({
                startDate: Yup.date().required(FormConst.VALIDATION_ERROR_REQUIRED),
                endDate: Yup.date().required(FormConst.VALIDATION_ERROR_REQUIRED)
                    .when('startDate', (startDate) => startDate && Yup.date().required(FormConst.VALIDATION_ERROR_REQUIRED)
                        .min(addDaysToDate(startDate, 1), "End date should be after start date")
                        .max(addDaysToDate(startDate, FormConst.MAX_YEARS_END_DATE*365), FormConst.VALIDATION_ERROR_MAX_END_DATE)),
                tier1: Yup.object().shape({
                    roomTypeGroups: Yup.array().of(
                        Yup.object().shape({
                            roomTypes: Yup.array().of(
                                Yup.object().shape({
                                    code: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
                                    isChecked: Yup.boolean().required(FormConst.VALIDATION_ERROR_REQUIRED)
                                })
                            ),
                            rates: Yup.object().shape({
                                [FormConst.FIELD_MONDAY]: Yup.object().shape({
                                    [FormConst.FIELD_1P]: this.rateAmountSchema,
                                    [FormConst.FIELD_2P]: this.rateAmountSchema
                                }),
                                [FormConst.FIELD_TUESDAY]: Yup.object().shape({
                                    [FormConst.FIELD_1P]: this.rateAmountSchema,
                                    [FormConst.FIELD_2P]: this.rateAmountSchema
                                }),
                                [FormConst.FIELD_WEDNESDAY]: Yup.object().shape({
                                    [FormConst.FIELD_1P]: this.rateAmountSchema,
                                    [FormConst.FIELD_2P]: this.rateAmountSchema
                                }),
                                [FormConst.FIELD_THURSDAY]: Yup.object().shape({
                                    [FormConst.FIELD_1P]: this.rateAmountSchema,
                                    [FormConst.FIELD_2P]: this.rateAmountSchema
                                }),
                                [FormConst.FIELD_FRIDAY]: Yup.object().shape({
                                    [FormConst.FIELD_1P]: this.rateAmountSchema,
                                    [FormConst.FIELD_2P]: this.rateAmountSchema
                                }),
                                [FormConst.FIELD_SATURDAY]: Yup.object().shape({
                                    [FormConst.FIELD_1P]: this.rateAmountSchema,
                                    [FormConst.FIELD_2P]: this.rateAmountSchema
                                }),
                                [FormConst.FIELD_SUNDAY]: Yup.object().shape({
                                    [FormConst.FIELD_1P]: this.rateAmountSchema,
                                    [FormConst.FIELD_2P]: this.rateAmountSchema
                                }),
                            })
                        })
                    ).test('Room type group selection', function (val) {
                        const totalRoomTypes = val[0].roomTypes?.length || 0
                        let selectedRoomTypes = []
                        let isMinCountPerGroup = true
                        val.forEach(roomTypeGroup => {
                            let selectedCountInGroup = 0
                            roomTypeGroup.roomTypes.forEach(roomType => {
                                if (roomType.isChecked) {
                                    selectedCountInGroup++
                                    selectedRoomTypes.push(roomType.code)
                                }
                            })
                            if (selectedCountInGroup === 0) {
                                isMinCountPerGroup = false
                            }
                        })

                        if (!isMinCountPerGroup) {
                            return this.createError({ message: 'You need to select at least one room type per group' })
                        }
                        let selectedRoomTypesSet = new Set()
                        selectedRoomTypes.forEach(roomType => selectedRoomTypesSet.add(roomType))
                        if (selectedRoomTypes.length > totalRoomTypes) {
                            return this.createError({ message: 'You can select a room type at most once' })
                        } else if (selectedRoomTypes.length < totalRoomTypes) {
                            return this.createError({ message: 'You need to select all room types at least once' })
                        } else if (selectedRoomTypesSet.size < totalRoomTypes) {
                            return this.createError({ message: 'You need to select all room types at least once' })
                        } else {
                            return true
                        }
                    })
                }),
                tier2: Yup.object().shape({
                    roomTypeGroups: this.roomTypeGroupsSchema
                }),
                tier3: Yup.object().shape({
                    roomTypeGroups: this.roomTypeGroupsSchema
                }),
                tier4: Yup.object().shape({
                    roomTypeGroups: this.roomTypeGroupsSchema
                }),
                sbase1: Yup.object().shape({
                    roomTypeGroups: this.roomTypeGroupsSchema
                }),
                sbase2: Yup.object().shape({
                    roomTypeGroups: this.roomTypeGroupsSchema
                }),
                sbase3: Yup.object().shape({
                    roomTypeGroups: this.roomTypeGroupsSchema
                }),
                sbase4: Yup.object().shape({
                    roomTypeGroups: this.roomTypeGroupsSchema
                })
            })
        ).test('Seasons dates test', function (seasons) {
            if (seasons.length > 1) {
                let dateRanges = []
                seasons.forEach(season => {
                    if (season.startDate && season.endDate) {
                        dateRanges.push({
                            startDate: season.startDate,
                            endDate: season.endDate
                        })
                    }
                })
                let overlappingDateRanges = multipleDateRangeOverlaps(dateRanges)
                if (isArrayNotEmpty(overlappingDateRanges)) {
                    return this.createError({
                        message: `There are overlapping date ranges for seasons: 
                    [${getDateStringFromDate(overlappingDateRanges[0].startDate)}, ${getDateStringFromDate(overlappingDateRanges[0].endDate)}] 
                    and 
                    [${getDateStringFromDate(overlappingDateRanges[1].startDate)}, ${getDateStringFromDate(overlappingDateRanges[1].endDate)}]`
                    })
                } else if (isArrayNotEmpty(getGapsInDateRanges(dateRanges))) {
                    const gaps = getGapsInDateRanges(dateRanges)
                    return this.createError(
                        {
                            message: `There are gaps in date ranges for seasons: `
                                + gaps.map(gap => getDateStringFromDate(gap.startDate) + ' to ' + getDateStringFromDate(gap.endDate)).join(', ')
                        })
                }
            }
            return true
        })
    })

    async componentDidMount() {

        if (isCompletedHotelInfoHistory(this.state.hotelInfoCompletedHistory)) {
            const roomTypes = this.state.hotelInfoCompletedHistory.newEntity?.hotelRoomTypes?.roomTypes;
            await this.populateBaseRatePlans(roomTypes);
        } else {
            await RoomTypesService.getRoomTypes({ hotelCode: this.state.hotelCode })
                .then(async (response) => {
                    let roomTypes = response.roomTypes
                    await this.populateBaseRatePlans(roomTypes);
                }).catch(error => {
                    this.setState({
                         errorMessage: 'Error while reading room types data. Please check with your Onboarding contact.',
                         isLoading: false,
                         showErrorModal: true
                    })
                })
        }
    }

    async populateBaseRatePlans(roomTypes) {
        if (isArrayNotEmpty(roomTypes)) {
            await RateplansService.getBaseRatePlans({hotelCode: this.state.hotelCode})
                .then(baseRatePlansResponse => {
                    this.setState({
                          roomTypes: roomTypes,
                          rateplans: baseRatePlansResponse.ratePlans,
                          initialValues: this.buildInitialValues(baseRatePlansResponse.ratePlans, roomTypes),
                          isLoading: false
                    })
                }).catch(error => {
                    this.setState({
                           roomTypes: roomTypes,
                           errorMessage: 'Error while reading rack rateplan data. Please check with your Onboarding contact.',
                           isLoading: false,
                           showErrorModal: true
                    })

                })
        } else {
            this.setState({
                 errorMessage: 'No room types defined',
                 isLoading: false,
                 showErrorModal: true
            })
        }
    }

    buildInitialValues = (rateplans, roomTypes) => {
        const today = getCurrentDate()
        const defaultStartDate = getDateStringFromDate(today)
        const defaultEndDate = getDateStringFromDate(addYearsToDate(today, FormConst.MIN_YEARS_RACK_RATE_DEFAULT))

        let showSeasons = true
        let showMultipleTiers = true

        const seasons = []
        const rackRateplan = searchFirstObjectInList(FormConst.FIELD_RATEPLAN_CODE, FormConst.RATEPLAN_CODE_BASE, rateplans)
        const allowSeasons = rackRateplan.allowSeasons
        let allRates = rackRateplan.rates

        // Set default values for flags
        let isSameRate1P2P = true
        let isSameRateDOW = true
        let isSameRateAllRoomTypes = true
        let isRateSeasonal = false

        if (isArrayNotEmpty(allRates)) {
            // Rates are already set
            // Sort by dates
            allRates = sortObjectList(allRates, 'startDate')
            // Group by dates
            allRates = groupBy(allRates, 'startDate')

            const numberOfSeasons = Object.keys(allRates).length
            if (numberOfSeasons === 1) {
                // 1. No seasons
                showSeasons = false
            } else {
                // 1. Multiple seasons
                isRateSeasonal = true
            }

            if (!this.state.isLinkedRateplanConfig) {
                for (const seasonStartDate in allRates) {
                    if (Object.hasOwnProperty.call(allRates, seasonStartDate)) {
                        const seasonRates = allRates[seasonStartDate];

                        // Build actual values to put in
                        const seasonToPush = {
                            startDate: seasonRates[0].startDate,
                            endDate: seasonRates[0].endDate,
                            'tier1': {
                                roomTypeGroups: []
                            },
                            'tier2': {
                                roomTypeGroups: []
                            },
                            'tier3': {
                                roomTypeGroups: []
                            },
                            'tier4': {
                                roomTypeGroups: []
                            }
                        }

                        // Extract tier rates
                        let tier1Rates = searchObjectList('tier', FormConst.TIER_1, seasonRates)
                        let tier2Rates = searchObjectList('tier', FormConst.TIER_2, seasonRates)
                        let tier3Rates = searchObjectList('tier', FormConst.TIER_3, seasonRates)
                        let tier4Rates = searchObjectList('tier', FormConst.TIER_4, seasonRates)

                        const ratesByTier = {
                            'tier1': tier1Rates,
                            'tier2': tier2Rates,
                            'tier3': tier3Rates,
                            'tier4': tier4Rates
                        }

                        if (isArrayNotEmpty(tier1Rates)) {
                            for (const tier in ratesByTier) {
                                if (Object.hasOwnProperty.call(ratesByTier, tier)) {
                                    const tierRates = ratesByTier[tier];
                                    let ratesGroupedByRoomTypes = groupBy(tierRates, 'roomTypes')
                                    ratesGroupedByRoomTypes = sortObjectByKeys(ratesGroupedByRoomTypes)

                                    for (const roomTypeCodesKey in ratesGroupedByRoomTypes) {
                                        if (Object.hasOwnProperty.call(ratesGroupedByRoomTypes, roomTypeCodesKey)) {
                                            const ratesPerRoomTypeGroup = ratesGroupedByRoomTypes[roomTypeCodesKey];

                                            if (ratesPerRoomTypeGroup[0].roomTypes.length === roomTypes.length) {
                                                // 2. Same rates for all room types
                                            } else {
                                                // 2. Different rates for all room types
                                                isSameRateAllRoomTypes = false
                                            }
                                            const dayOfWeekFlags = ratesPerRoomTypeGroup[0].dayOfWeek
                                            for (const dayOfWeek in dayOfWeekFlags) {
                                                if (Object.hasOwnProperty.call(dayOfWeekFlags, dayOfWeek)) {
                                                    const dayOfWeekFlag = dayOfWeekFlags[dayOfWeek];
                                                    if (!dayOfWeekFlag) {
                                                        isSameRateDOW = false
                                                        break
                                                    }
                                                }
                                            }

                                            const roomTypeGroupToPush = {
                                                roomTypes: roomTypes.map(roomType => {
                                                    return {
                                                        code: roomType.hotelRoomTypeCode,
                                                        isChecked: ratesPerRoomTypeGroup[0].roomTypes.includes(roomType.hotelRoomTypeCode)
                                                    }
                                                }),
                                                rates: {}
                                            }

                                            ratesPerRoomTypeGroup.forEach(rate => {
                                                const prices = rate.prices
                                                const price1P = searchFirstObjectInList('condition', FormConst.CONDITION_VALUE_ONE_PERSON, prices)
                                                const price2P = searchFirstObjectInList('condition', FormConst.CONDITION_VALUE_TWO_PERSON, prices)
                                                if (price1P.amount !== price2P.amount) {
                                                    isSameRate1P2P = false
                                                }

                                                this.daysOfWeek.map(day => {
                                                    if (rate.dayOfWeek[day]) {
                                                        roomTypeGroupToPush.rates[day] = {
                                                            [FormConst.FIELD_1P]: price1P.amount || 0.00,
                                                            [FormConst.FIELD_2P]: price2P.amount || 0.00
                                                        }
                                                    }
                                                })

                                            })
                                            seasonToPush[tier].roomTypeGroups.push(roomTypeGroupToPush)
                                        }
                                    }
                                }
                            }
                        }
                        seasons.push(seasonToPush)
                    }
                }
            } else {

                const sbase1 = searchFirstObjectInList(FormConst.FIELD_RATEPLAN_CODE, FormConst.RATEPLAN_CODE_SBASE1, rateplans)
                const sbase2 = searchFirstObjectInList(FormConst.FIELD_RATEPLAN_CODE, FormConst.RATEPLAN_CODE_SBASE2, rateplans)
                const sbase3 = searchFirstObjectInList(FormConst.FIELD_RATEPLAN_CODE, FormConst.RATEPLAN_CODE_SBASE3, rateplans)
                const sbase4 = searchFirstObjectInList(FormConst.FIELD_RATEPLAN_CODE, FormConst.RATEPLAN_CODE_SBASE4, rateplans)

                let allSbase1Rates = sbase1.rates
                let allSbase2Rates = sbase2.rates
                let allSbase3Rates = sbase3.rates
                let allSbase4Rates = sbase4.rates

                // Sort by dates
                allSbase1Rates = sortObjectList(allSbase1Rates, 'startDate')
                allSbase2Rates = sortObjectList(allSbase2Rates, 'startDate')
                allSbase3Rates = sortObjectList(allSbase3Rates, 'startDate')
                allSbase4Rates = sortObjectList(allSbase4Rates, 'startDate')

                // Group by dates
                allSbase1Rates = groupBy(allSbase1Rates, 'startDate')
                allSbase2Rates = groupBy(allSbase2Rates, 'startDate')
                allSbase3Rates = groupBy(allSbase3Rates, 'startDate')
                allSbase4Rates = groupBy(allSbase4Rates, 'startDate')

                for (const seasonStartDate in allRates) {
                    if (Object.hasOwnProperty.call(allRates, seasonStartDate)) {
                        const seasonRates = allRates[seasonStartDate];
                        const sbase1SeasonRates = allSbase1Rates[seasonStartDate];
                        const sbase2SeasonRates = allSbase2Rates[seasonStartDate];
                        const sbase3SeasonRates = allSbase3Rates[seasonStartDate];
                        const sbase4SeasonRates = allSbase4Rates[seasonStartDate];

                        // Build actual values to put in
                        const seasonToPush = {
                            startDate: seasonRates[0].startDate,
                            endDate: seasonRates[0].endDate,
                            'tier1': {
                                roomTypeGroups: []
                            },
                            'sbase1': {
                                roomTypeGroups: []
                            },
                            'sbase2': {
                                roomTypeGroups: []
                            },
                            'sbase3': {
                                roomTypeGroups: []
                            },
                            'sbase4': {
                                roomTypeGroups: []
                            }
                        }

                        // Extract tier rates
                        let tier1Rates = searchObjectList('tier', FormConst.TIER_1, seasonRates)
                        let sbase1Tier1Rates = searchObjectList('tier', FormConst.TIER_1, sbase1SeasonRates)
                        let sbase2Tier1Rates = searchObjectList('tier', FormConst.TIER_1, sbase2SeasonRates)
                        let sbase3Tier1Rates = searchObjectList('tier', FormConst.TIER_1, sbase3SeasonRates)
                        let sbase4Tier1Rates = searchObjectList('tier', FormConst.TIER_1, sbase4SeasonRates)
                        const ratesByTier = {
                            'tier1': tier1Rates,
                            'sbase1': sbase1Tier1Rates,
                            'sbase2': sbase2Tier1Rates,
                            'sbase3': sbase3Tier1Rates,
                            'sbase4': sbase4Tier1Rates
                        }

                        if (isArrayNotEmpty(tier1Rates)) {
                            for (const tier in ratesByTier) {
                                if (Object.hasOwnProperty.call(ratesByTier, tier)) {
                                    const tierRates = ratesByTier[tier];
                                    let ratesGroupedByRoomTypes = groupBy(tierRates, 'roomTypes')
                                    ratesGroupedByRoomTypes = sortObjectByKeys(ratesGroupedByRoomTypes)

                                    for (const roomTypeCodesKey in ratesGroupedByRoomTypes) {
                                        if (Object.hasOwnProperty.call(ratesGroupedByRoomTypes, roomTypeCodesKey)) {
                                            const ratesPerRoomTypeGroup = ratesGroupedByRoomTypes[roomTypeCodesKey];

                                            if (ratesPerRoomTypeGroup[0].roomTypes.length === roomTypes.length) {
                                                // 2. Same rates for all room types
                                            } else {
                                                // 2. Different rates for all room types
                                                isSameRateAllRoomTypes = false
                                            }
                                            const dayOfWeekFlags = ratesPerRoomTypeGroup[0].dayOfWeek
                                            for (const dayOfWeek in dayOfWeekFlags) {
                                                if (Object.hasOwnProperty.call(dayOfWeekFlags, dayOfWeek)) {
                                                    const dayOfWeekFlag = dayOfWeekFlags[dayOfWeek];
                                                    if (!dayOfWeekFlag) {
                                                        isSameRateDOW = false
                                                        break
                                                    }
                                                }
                                            }

                                            const roomTypeGroupToPush = {
                                                roomTypes: roomTypes.map(roomType => {
                                                    return {
                                                        code: roomType.hotelRoomTypeCode,
                                                        isChecked: ratesPerRoomTypeGroup[0].roomTypes.includes(roomType.hotelRoomTypeCode)
                                                    }
                                                }),
                                                rates: {}
                                            }

                                            ratesPerRoomTypeGroup.forEach(rate => {
                                                const prices = rate.prices
                                                const price1P = searchFirstObjectInList('condition', FormConst.CONDITION_VALUE_ONE_PERSON, prices)
                                                const price2P = searchFirstObjectInList('condition', FormConst.CONDITION_VALUE_TWO_PERSON, prices)
                                                if (price1P.amount !== price2P.amount) {
                                                    isSameRate1P2P = false
                                                }

                                                this.daysOfWeek.map(day => {
                                                    if (rate.dayOfWeek[day]) {
                                                        roomTypeGroupToPush.rates[day] = {
                                                            [FormConst.FIELD_1P]: price1P.amount || 0.00,
                                                            [FormConst.FIELD_2P]: price2P.amount || 0.00
                                                        }
                                                    }
                                                })

                                            })
                                            seasonToPush[tier].roomTypeGroups.push(roomTypeGroupToPush)
                                        }
                                    }
                                }
                            }
                        }
                        seasons.push(seasonToPush)
                    }
                }
            }
        } else {
            seasons.push({
                startDate: defaultStartDate,
                endDate: defaultEndDate,
                tier1: {
                    roomTypeGroups: [
                        {
                            roomTypes: roomTypes.map(roomType => {
                                return {
                                    code: roomType.hotelRoomTypeCode,
                                    isChecked: true
                                }
                            }),
                            rates: { ...this.dayOfTheWeekRates }
                        }
                    ]
                }
            })
            showSeasons = false
            showMultipleTiers = false
        }

        return {
            isSameRate1P2P: this.state.isMultiTier ? true : isSameRate1P2P,
            isSameRateDOW: isSameRateDOW,
            isSameRateAllRoomTypes: isSameRateAllRoomTypes,
            isRateSeasonal: allowSeasons ? isRateSeasonal : false,
            allowSeasons: allowSeasons,
            showSeasons: allowSeasons && showSeasons,
            showMultipleTiers: this.state.isMultiTier && showMultipleTiers,
            seasons: allowSeasons ? seasons : [...seasons[0]]
        }
    }

    deleteRoomTypeGroup = (values, seasonIndex, roomTypeGroupIndex) => {
        let seasons = values.seasons
        let season = seasons[seasonIndex]
        let roomTypeGroups = season.tier1.roomTypeGroups
        roomTypeGroups.splice(roomTypeGroupIndex, 1)

        if (roomTypeGroups.length === 1) {
            roomTypeGroups[0].roomTypes.forEach(roomType => {
                roomType.isChecked = true
            })
        }

        this.setState({
            initialValues: {
                ...values,
                seasons: [...seasons]
            }
        })
    }

    splitRoomTypes = (values, seasonIndex) => {
        let seasons = values.seasons
        let season = seasons[seasonIndex]
        season.tier1.roomTypeGroups
            .push(this.cloneRoomTypeGroup(season.tier1.roomTypeGroups[season.tier1.roomTypeGroups.length - 1], false))
        this.setState({
            initialValues: {
                ...values,
                seasons: [...seasons]
            }
        })
    }

    addTiers = (values) => {
        let seasons = values.seasons
        let firstSeason = seasons[0]

        this.state.tierLabels.forEach((tierLabel) => {
            if (tierLabel !== 'tier1') {
                let isCopyRates = false
                if (tierLabel === 'sbase1') {
                    isCopyRates = true
                }
                firstSeason[tierLabel] = this.cloneTier(firstSeason.tier1, isCopyRates)
            }
        })

        this.setState({
            initialValues: {
                ...values,
                seasons: [firstSeason],
                showMultipleTiers: true
            },
        })
    }

    deleteTiers = (values) => {
        let seasons = values.seasons

        let firstSeason = seasons[0]

        firstSeason = {
            ...firstSeason,
            tier2: {},
            tier3: {},
            tier4: {},
            sbase1: {},
            sbase2: {},
            sbase3: {},
            sbase4: {}
        }

        this.setState({
            initialValues: {
                ...values,
                seasons: [firstSeason],
                showMultipleTiers: false,
                showSeasons: false
            },
            showEditTier1Modal: false
        })
    }

    addSeason = (values) => {
        let seasons = values.seasons

        let newSeasonStartDate = ''
        let newSeasonEndDate = ''

        // If the preceding season has an end date, then use it to set the start date of new season
        const seasonsLength = seasons.length
        if (seasonsLength > 0) {
            const lastSeason = seasons[seasonsLength - 1]
            if (lastSeason?.endDate) {
                newSeasonStartDate = getDateStringFromDate(addDaysToDate(getDateFromDateString(lastSeason.endDate), 1))
            }
        }

        const seasonIndexWithMostRoomTypeGroups = this.findSeasonWithMostRoomTypeGroups(seasons)

        seasons.push({
            startDate: newSeasonStartDate,
            endDate: newSeasonEndDate,
            tier1: this.cloneTier(seasons[seasonIndexWithMostRoomTypeGroups].tier1, false),
            tier2: this.cloneTier(seasons[seasonIndexWithMostRoomTypeGroups].tier2, false),
            tier3: this.cloneTier(seasons[seasonIndexWithMostRoomTypeGroups].tier3, false),
            tier4: this.cloneTier(seasons[seasonIndexWithMostRoomTypeGroups].tier4, false),
            sbase1: this.cloneTier(seasons[seasonIndexWithMostRoomTypeGroups].sbase1, false),
            sbase2: this.cloneTier(seasons[seasonIndexWithMostRoomTypeGroups].sbase2, false),
            sbase3: this.cloneTier(seasons[seasonIndexWithMostRoomTypeGroups].sbase3, false),
            sbase4: this.cloneTier(seasons[seasonIndexWithMostRoomTypeGroups].sbase4, false)
        })

        this.setState({
            initialValues: {
                ...values,
                seasons: [...seasons],
                showSeasons: true
            }
        })
    }

    findSeasonWithMostRoomTypeGroups = (seasons) => {
        let seasonIndexResult = 0
        let maxRoomTypeGroups = 0
        seasons.forEach((season, seasonIndex) => {
            const tierRoomTypeGroupLengths = []
            if (!isObjectEmpty(season.tier1)) {
                tierRoomTypeGroupLengths.push(season.tier1.roomTypeGroups.length)
            }
            if (!isObjectEmpty(season.tier2)) {
                tierRoomTypeGroupLengths.push(season.tier2.roomTypeGroups.length)
            }
            if (!isObjectEmpty(season.tier3)) {
                tierRoomTypeGroupLengths.push(season.tier3.roomTypeGroups.length)
            }
            if (!isObjectEmpty(season.tier4)) {
                tierRoomTypeGroupLengths.push(season.tier4.roomTypeGroups.length)
            }
            if (!isObjectEmpty(season.sbase1)) {
                tierRoomTypeGroupLengths.push(season.sbase1.roomTypeGroups.length)
            }
            if (!isObjectEmpty(season.sbase2)) {
                tierRoomTypeGroupLengths.push(season.sbase2.roomTypeGroups.length)
            }
            if (!isObjectEmpty(season.sbase3)) {
                tierRoomTypeGroupLengths.push(season.sbase3.roomTypeGroups.length)
            }
            if (!isObjectEmpty(season.sbase4)) {
                tierRoomTypeGroupLengths.push(season.sbase4.roomTypeGroups.length)
            }

            const maxRoomTypeGroupsForSeason = Math.max(...tierRoomTypeGroupLengths)

            if (maxRoomTypeGroupsForSeason > maxRoomTypeGroups) {
                maxRoomTypeGroups = maxRoomTypeGroupsForSeason
                seasonIndexResult = seasonIndex
            }
        })
        return seasonIndexResult
    }

    deleteSeason = (values, seasonIndex) => {
        let seasons = values.seasons
        seasons.splice(seasonIndex, 1)

        this.setState({
            initialValues: {
                ...values,
                seasons: [...seasons]
            }
        })
    }

    deleteSeasons = (values) => {
        let seasons = values.seasons

        this.setState({
            initialValues: {
                ...values,
                isRateSeasonal: false,
                seasons: [seasons[0]],
                showSeasons: false
            },
            showEditSeasonModal: false
        })
    }

    handleRoomTypeMerge = (values) => {
        let seasons = values.seasons

        let firstSeason = seasons[0]
        let singleRoomTypeGroup = firstSeason.tier1.roomTypeGroups[0]

        singleRoomTypeGroup.roomTypes = singleRoomTypeGroup.roomTypes.map(roomType => {
            return {
                ...roomType,
                isChecked: true
            }
        })

        firstSeason = {
            ...firstSeason,
            tier1: {
                roomTypeGroups: [singleRoomTypeGroup]
            }
        }

        this.setState({
            initialValues: {
                ...values,
                isSameRateAllRoomTypes: true,
                seasons: [firstSeason]
            }
        })
    }

    cloneTier = (tierData, isCopyRates) => {
        let clonedTier = {
            roomTypeGroups: []
        }

        if (!isObjectEmpty(tierData) && isArrayNotEmpty(tierData.roomTypeGroups)) {
            tierData.roomTypeGroups.forEach(roomTypeGroup => {
                clonedTier.roomTypeGroups.push(this.cloneRoomTypeGroup(roomTypeGroup, isCopyRates))
            })
        }
        return clonedTier
    }

    cloneRoomTypeGroup = (roomTypeGroup, isCopyRates) => {
        const clonedRoomTypeGroup = {
            roomTypes: [],
            rates: {}
        }

        if (isArrayNotEmpty(roomTypeGroup.roomTypes)) {
            roomTypeGroup.roomTypes.forEach(roomType => {
                clonedRoomTypeGroup.roomTypes.push({
                    ...roomType
                })
            })
        }

        if (isCopyRates && !isObjectEmpty(roomTypeGroup.rates)) {
            clonedRoomTypeGroup.rates = {
                [FormConst.FIELD_MONDAY]: {
                    [FormConst.FIELD_1P]: roomTypeGroup.rates[FormConst.FIELD_MONDAY][FormConst.FIELD_1P],
                    [FormConst.FIELD_2P]: roomTypeGroup.rates[FormConst.FIELD_MONDAY][FormConst.FIELD_2P],
                },
                [FormConst.FIELD_TUESDAY]: {
                    [FormConst.FIELD_1P]: roomTypeGroup.rates[FormConst.FIELD_TUESDAY][FormConst.FIELD_1P],
                    [FormConst.FIELD_2P]: roomTypeGroup.rates[FormConst.FIELD_TUESDAY][FormConst.FIELD_2P],
                },
                [FormConst.FIELD_WEDNESDAY]: {
                    [FormConst.FIELD_1P]: roomTypeGroup.rates[FormConst.FIELD_WEDNESDAY][FormConst.FIELD_1P],
                    [FormConst.FIELD_2P]: roomTypeGroup.rates[FormConst.FIELD_WEDNESDAY][FormConst.FIELD_2P],
                },
                [FormConst.FIELD_THURSDAY]: {
                    [FormConst.FIELD_1P]: roomTypeGroup.rates[FormConst.FIELD_THURSDAY][FormConst.FIELD_1P],
                    [FormConst.FIELD_2P]: roomTypeGroup.rates[FormConst.FIELD_THURSDAY][FormConst.FIELD_2P],
                },
                [FormConst.FIELD_FRIDAY]: {
                    [FormConst.FIELD_1P]: roomTypeGroup.rates[FormConst.FIELD_FRIDAY][FormConst.FIELD_1P],
                    [FormConst.FIELD_2P]: roomTypeGroup.rates[FormConst.FIELD_FRIDAY][FormConst.FIELD_2P],
                },
                [FormConst.FIELD_SATURDAY]: {
                    [FormConst.FIELD_1P]: roomTypeGroup.rates[FormConst.FIELD_SATURDAY][FormConst.FIELD_1P],
                    [FormConst.FIELD_2P]: roomTypeGroup.rates[FormConst.FIELD_SATURDAY][FormConst.FIELD_2P],
                },
                [FormConst.FIELD_SUNDAY]: {
                    [FormConst.FIELD_1P]: roomTypeGroup.rates[FormConst.FIELD_SUNDAY][FormConst.FIELD_1P],
                    [FormConst.FIELD_2P]: roomTypeGroup.rates[FormConst.FIELD_SUNDAY][FormConst.FIELD_2P],
                }
            }
        } else {
            clonedRoomTypeGroup.rates = {
                [FormConst.FIELD_MONDAY]: {
                    [FormConst.FIELD_1P]: 0.00,
                    [FormConst.FIELD_2P]: 0.00,
                },
                [FormConst.FIELD_TUESDAY]: {
                    [FormConst.FIELD_1P]: 0.00,
                    [FormConst.FIELD_2P]: 0.00,
                },
                [FormConst.FIELD_WEDNESDAY]: {
                    [FormConst.FIELD_1P]: 0.00,
                    [FormConst.FIELD_2P]: 0.00,
                },
                [FormConst.FIELD_THURSDAY]: {
                    [FormConst.FIELD_1P]: 0.00,
                    [FormConst.FIELD_2P]: 0.00,
                },
                [FormConst.FIELD_FRIDAY]: {
                    [FormConst.FIELD_1P]: 0.00,
                    [FormConst.FIELD_2P]: 0.00,
                },
                [FormConst.FIELD_SATURDAY]: {
                    [FormConst.FIELD_1P]: 0.00,
                    [FormConst.FIELD_2P]: 0.00,
                },
                [FormConst.FIELD_SUNDAY]: {
                    [FormConst.FIELD_1P]: 0.00,
                    [FormConst.FIELD_2P]: 0.00,
                }
            }
        }
        return clonedRoomTypeGroup
    }

    handleSubmit = (data) => {
        if (!this.state.isLinkedRateplanConfig) {

            let existingRateplan = {
                ...this.state.rateplans[0]
            }

            let baseRateplan = {
                ratePlanType: existingRateplan.ratePlanType,
                ratePlanCode: existingRateplan.ratePlanCode,
                ratePlanName: existingRateplan.ratePlanName,
                rates: []
            }

            data.seasons.forEach(season => {

                this.state.tierLabels.forEach(tierLabel => {
                    season[tierLabel].roomTypeGroups.map(roomTypeGroup => {

                        const rates = roomTypeGroup.rates

                        if (data.isSameRateDOW) {
                            let prices = []
                            prices.push({
                                condition: FormConst.CONDITION_VALUE_ONE_PERSON,
                                amount: rates[FormConst.FIELD_MONDAY][FormConst.FIELD_1P]
                            })
                            prices.push({
                                condition: FormConst.CONDITION_VALUE_TWO_PERSON,
                                amount: data.isSameRate1P2P ? rates[FormConst.FIELD_MONDAY][FormConst.FIELD_1P] : rates[FormConst.FIELD_MONDAY][FormConst.FIELD_2P]
                            })
                            baseRateplan.rates.push({
                                tier: this.tierValues[tierLabel],
                                startDate: season.startDate,
                                endDate: season.endDate,
                                dayOfWeek: this.dayOfTheWeekConstantAllTrue,
                                roomTypes: roomTypeGroup.roomTypes.filter(roomType => roomType.isChecked).map(roomType => roomType.code),
                                prices: prices
                            })
                        } else {
                            Object.keys(rates).forEach(day => {
                                const rate = rates[day]
                                let prices = []
                                prices.push({
                                    condition: FormConst.CONDITION_VALUE_ONE_PERSON,
                                    amount: rate[FormConst.FIELD_1P]
                                })
                                prices.push({
                                    condition: FormConst.CONDITION_VALUE_TWO_PERSON,
                                    amount: data.isSameRate1P2P ? rate[FormConst.FIELD_1P] : rate[FormConst.FIELD_2P]
                                })
                                baseRateplan.rates.push({
                                    tier: this.tierValues[tierLabel],
                                    startDate: season.startDate,
                                    endDate: season.endDate,
                                    dayOfWeek: {
                                        ...this.dayOfTheWeekConstantAllFalse,
                                        [day]: true
                                    },
                                    roomTypes: roomTypeGroup.roomTypes.filter(roomType => roomType.isChecked).map(roomType => roomType.code),
                                    prices: prices
                                })
                            })
                        }
                    })
                })
            })


            let putData = {
                hotelCode: this.state.hotelCode,
                ratePlans: [baseRateplan]
            }

            this.props.onPut(putData)
            this.setState({
                isLoading: true
            })
        } else {
            let existingBase = searchFirstObjectInList(FormConst.FIELD_RATEPLAN_CODE, 'BASE', this.state.rateplans)
            let existingSBase1 = searchFirstObjectInList(FormConst.FIELD_RATEPLAN_CODE, 'SBASE1', this.state.rateplans)
            let existingSBase2 = searchFirstObjectInList(FormConst.FIELD_RATEPLAN_CODE, 'SBASE2', this.state.rateplans)
            let existingSBase3 = searchFirstObjectInList(FormConst.FIELD_RATEPLAN_CODE, 'SBASE3', this.state.rateplans)
            let existingSBase4 = searchFirstObjectInList(FormConst.FIELD_RATEPLAN_CODE, 'SBASE4', this.state.rateplans)

            let rateplans = {
                tier1: {
                    ratePlanType: existingBase.ratePlanType,
                    ratePlanCode: existingBase.ratePlanCode,
                    ratePlanName: existingBase.ratePlanName,
                    rates: []
                },
                sbase1: {
                    ratePlanType: existingSBase1.ratePlanType,
                    ratePlanCode: existingSBase1.ratePlanCode,
                    ratePlanName: existingSBase1.ratePlanName,
                    rates: []
                },
                sbase2: {
                    ratePlanType: existingSBase2.ratePlanType,
                    ratePlanCode: existingSBase2.ratePlanCode,
                    ratePlanName: existingSBase2.ratePlanName,
                    rates: []
                },
                sbase3: {
                    ratePlanType: existingSBase3.ratePlanType,
                    ratePlanCode: existingSBase3.ratePlanCode,
                    ratePlanName: existingSBase3.ratePlanName,
                    rates: []
                },
                sbase4: {
                    ratePlanType: existingSBase4.ratePlanType,
                    ratePlanCode: existingSBase4.ratePlanCode,
                    ratePlanName: existingSBase4.ratePlanName,
                    rates: []
                }
            }

            data.seasons.forEach(season => {

                this.state.tierLabels.forEach(tierLabel => {
                    season[tierLabel].roomTypeGroups.map(roomTypeGroup => {

                        const rates = roomTypeGroup.rates

                        if (data.isSameRateDOW) {
                            let prices = []
                            prices.push({
                                condition: FormConst.CONDITION_VALUE_ONE_PERSON,
                                amount: rates[FormConst.FIELD_MONDAY][FormConst.FIELD_1P]
                            })
                            prices.push({
                                condition: FormConst.CONDITION_VALUE_TWO_PERSON,
                                amount: data.isSameRate1P2P ? rates[FormConst.FIELD_MONDAY][FormConst.FIELD_1P] : rates[FormConst.FIELD_MONDAY][FormConst.FIELD_2P]
                            })
                            rateplans[tierLabel].rates.push({
                                tier: FormConst.TIER_1,
                                startDate: season.startDate,
                                endDate: season.endDate,
                                dayOfWeek: this.dayOfTheWeekConstantAllTrue,
                                roomTypes: roomTypeGroup.roomTypes.filter(roomType => roomType.isChecked).map(roomType => roomType.code),
                                prices: prices
                            })
                        } else {
                            Object.keys(rates).forEach(day => {
                                const rate = rates[day]
                                let prices = []
                                prices.push({
                                    condition: FormConst.CONDITION_VALUE_ONE_PERSON,
                                    amount: rate[FormConst.FIELD_1P]
                                })
                                prices.push({
                                    condition: FormConst.CONDITION_VALUE_TWO_PERSON,
                                    amount: data.isSameRate1P2P ? rate[FormConst.FIELD_1P] : rate[FormConst.FIELD_2P]
                                })
                                rateplans[tierLabel].rates.push({
                                    tier: FormConst.TIER_1,
                                    startDate: season.startDate,
                                    endDate: season.endDate,
                                    dayOfWeek: {
                                        ...this.dayOfTheWeekConstantAllFalse,
                                        [day]: true
                                    },
                                    roomTypes: roomTypeGroup.roomTypes.filter(roomType => roomType.isChecked).map(roomType => roomType.code),
                                    prices: prices
                                })
                            })
                        }
                    })
                })
            })

            let putData = {
                hotelCode: this.state.hotelCode,
                ratePlans: Object.keys(rateplans).map(rateplanName => rateplans[rateplanName])
            }

            this.props.onPut(putData)
            this.setState({
                isLoading: true
            })
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.count !== this.props.count) {
            if (this.props.errorMessage) {
                this.setState({ isLoading: false, showErrorModal: true, errorMessage: this.props.errorDescription })
            } else {
                this.props.history.push(RouteConst.ROUTE_RATEPLANS_PAGE)
            }
        }
    }

    render() {
        return (
            <Formik
                initialValues={this.state.initialValues}
                validationSchema={this.validationSchema}
                enableReinitialize={true}
                onSubmit={(data, { setSubmitting }) => {
                    setSubmitting(true)
                    this.handleSubmit(data)
                    setSubmitting(false)
                }}>
                {
                    ({ values, errors, resetForm, handleChange }) => {
                        const isMaxSeasons = values.seasons.length >= 30;
                        return (
                            <Form>
                                <h5 className='d-block d-xl-none text-center mt-5'>{FormConst.PAGE_NOT_ACCESSIBLE_ON_DEVICE}</h5>
                                <div className='d-none d-xl-block rack-rates-form-fields'>
                                    <nav aria-label="breadcrumb">
                                        <ol className="breadcrumb">
                                            <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_HOME_PAGE}>Home</NavLink></li>
                                            <li className="breadcrumb-item active" aria-current="page">Rack Rates</li>
                                        </ol>
                                    </nav>

                                    <p className='helper-text'>
                                        Please fill out the information for RACK rates.
                                        Please make sure you answer the initial questions for Rate Options accurately before entering the actual rates. Changing these options will change the associated rates.
                                        If you want to add multiple seasons, make sure you get the configuration and rates for Season 1 correct before adding more seasons. The same configuration will be used for all seasons. If you wish to edit Season 1 after adding other seasons, all of the data for seasons except Season 1 will be lost.
                                    </p>
                                    <p className='rack-rates-title'>Rate Options</p>
                                    {
                                        !this.state.isMultiTier
                                        && <ToggleSwitch
                                            id='isSameRate1P2P'
                                            name='isSameRate1P2P'
                                            checked={values.isSameRate1P2P}
                                            label='Use the same rate for 1 and 2 guests in a room?'
                                            options={FormConst.SWITCH_OPTIONS_YES_NO}
                                            onChange={
                                                e => {
                                                    if (!values.showSeasons && !values.showMultipleTiers) {
                                                        handleChange(e)
                                                    }
                                                }
                                            }
                                            disabled={values.showSeasons || values.showMultipleTiers} />
                                    }
                                    <ToggleSwitch
                                        id='isSameRateDOW'
                                        name='isSameRateDOW'
                                        checked={values.isSameRateDOW}
                                        label='Use the same rate for each day of the week?'
                                        options={FormConst.SWITCH_OPTIONS_YES_NO}
                                        onChange={e => {
                                            if (!values.showSeasons && !values.showMultipleTiers) {
                                                handleChange(e)
                                            }
                                        }}
                                        disabled={values.showSeasons || values.showMultipleTiers} />
                                    <ToggleSwitch
                                        id='isSameRateAllRoomTypes'
                                        name='isSameRateAllRoomTypes'
                                        checked={values.isSameRateAllRoomTypes}
                                        label='Use the same rate for all room types?'
                                        options={FormConst.SWITCH_OPTIONS_YES_NO}
                                        onChange={e => {
                                            if (!values.showSeasons && !values.showMultipleTiers) {
                                                if (e.target.value === 'on') {
                                                    this.handleRoomTypeMerge(values)
                                                    handleChange(e)
                                                } else {
                                                    handleChange(e)
                                                }
                                            }
                                        }}
                                        disabled={values.showSeasons || values.showMultipleTiers} />
                                    {
                                        values.allowSeasons
                                        && <ToggleSwitch
                                            id='isRateSeasonal'
                                            name='isRateSeasonal'
                                            checked={values.isRateSeasonal}
                                            label='Does the rate change during the year?'
                                            options={FormConst.SWITCH_OPTIONS_YES_NO}
                                            onChange={e => {
                                                if (!values.showSeasons && !values.showMultipleTiers) {
                                                    if (e.target.value === 'on') {
                                                        this.deleteSeasons(values)
                                                        handleChange(e)
                                                    } else {
                                                        handleChange(e)
                                                    }
                                                }
                                            }
                                            }
                                            disabled={values.showSeasons || values.showMultipleTiers} />
                                    }
                                    {
                                        values.seasons.map((season, seasonIndex) => {
                                            return <div key={`season-${seasonIndex}-details`} className='season-details'>
                                                <p className='season-title'>
                                                    {values.seasons.length > 1 ? `Season ${seasonIndex + 1}` : 'Rates'}
                                                    {
                                                        values.showSeasons
                                                        && seasonIndex === 0
                                                        && (
                                                            <Button role='link' name='Edit Season 1' onClick={() => {
                                                                this.setState({
                                                                    showEditSeasonModal: true
                                                                })
                                                            }} />
                                                        )
                                                    }
                                                    {
                                                        seasonIndex !== 0
                                                        && (
                                                            <Button
                                                                role='link'
                                                                name='Delete Season'
                                                                onClick={() => this.deleteSeason(values, seasonIndex)} />
                                                        )
                                                    }
                                                </p>
                                                <Row className='season-dates'>
                                                    <Col xl={6}>
                                                        <TextInput
                                                            id={`season-${seasonIndex}-startDate`}
                                                            name={`seasons.${seasonIndex}.startDate`}
                                                            type='date'
                                                            label='Start Date'
                                                            isrequired='true' />
                                                    </Col>
                                                    <Col xl={6}>
                                                        <TextInput
                                                            id={`season-${seasonIndex}-endDate`}
                                                            name={`seasons.${seasonIndex}.endDate`}
                                                            type='date'
                                                            label='End Date'
                                                            min={values.seasons[seasonIndex].startDate}
                                                            isrequired='true' />
                                                    </Col>
                                                    <Col>
                                                        {
                                                            errors
                                                            && errors.seasons
                                                            && typeof (errors.seasons) === 'string'
                                                            && <p className='error mt-3 text-bold'>{errors.seasons}</p>
                                                        }
                                                    </Col>
                                                </Row>
                                                {
                                                    this.state.tierLabels.map((tierLabel, tierIndex) => {
                                                        return <div className='tier-details' key={`season-${seasonIndex}-${tierLabel}-details`}>
                                                            {
                                                                (values.showMultipleTiers || tierIndex === 0)
                                                                && <div key={`season-${seasonIndex}-${tierLabel}`} className='tier-details'>
                                                                    {
                                                                        <p className='tier-title'>
                                                                            {
                                                                                this.state.isMultiTier && values.showMultipleTiers
                                                                                    ? (tierLabel === 'tier1' && this.state.isLinkedRateplanConfig ? 'BASE' : this.tierDisplayLabels[tierLabel]) : ''}
                                                                            {
                                                                                values.seasons.length === 1
                                                                                && this.state.isMultiTier
                                                                                && values.showMultipleTiers
                                                                                && seasonIndex === 0
                                                                                && tierIndex === 0
                                                                                && (
                                                                                    <Button role='link' name={tierLabel === 'tier1' && this.state.isLinkedRateplanConfig ? 'Edit Base' : 'Edit Tier 1'} onClick={() => {
                                                                                        this.setState({
                                                                                            showEditTier1Modal: true
                                                                                        })
                                                                                    }} />
                                                                                )
                                                                            }
                                                                        </p>
                                                                    }
                                                                    {
                                                                        season[tierLabel].roomTypeGroups.map((roomTypeGroup, roomTypeGroupIndex) => {
                                                                            return <Row className='room-type-groups' key={`season-${seasonIndex}-${tierLabel}-roomTypeGroup-${roomTypeGroupIndex}`}>
                                                                                <Col xl={12} className='room-types'>
                                                                                    <p className='room-types-label'>
                                                                                        Room Types:
                                                                                        {/* Room Type Group {roomTypeGroupIndex + 1}: */}
                                                                                        {
                                                                                            !values.showSeasons && !values.showMultipleTiers && roomTypeGroupIndex > 0
                                                                                            && (
                                                                                                <Button
                                                                                                    name='Delete'
                                                                                                    role='link'
                                                                                                    onClick={() => this.deleteRoomTypeGroup(values, seasonIndex, roomTypeGroupIndex)} />

                                                                                            )
                                                                                        }
                                                                                    </p>
                                                                                    {
                                                                                        roomTypeGroup.roomTypes.map((roomType, roomTypeIndex) => <>
                                                                                                <TextInput
                                                                                                    key={`season-${seasonIndex}-${tierLabel}-roomTypeGroup-${roomTypeGroupIndex}-roomType-${roomTypeIndex}`}
                                                                                                    id={`season-${seasonIndex}-${tierLabel}-roomTypeGroups-${roomTypeGroupIndex}-roomTypes-${roomTypeIndex}`}
                                                                                                    name={`seasons.${seasonIndex}.${tierLabel}.roomTypeGroups.${roomTypeGroupIndex}.roomTypes.${roomTypeIndex}.isChecked`} type='checkbox'
                                                                                                    value={roomType.isChecked}
                                                                                                    checked={roomType.isChecked}
                                                                                                    suffix={roomType.code}
                                                                                                    disabled={values.showMultipleTiers || values.isSameRateAllRoomTypes || values.showSeasons} />
                                                                                            </>
                                                                                        )
                                                                                    }
                                                                                    {
                                                                                        seasonIndex === 0 && isArrayNotEmpty(errors.seasons)
                                                                                        && errors.seasons[seasonIndex]
                                                                                        && errors.seasons[seasonIndex].tier1 && errors.seasons[seasonIndex].tier1.roomTypeGroups
                                                                                        && typeof (errors.seasons[seasonIndex].tier1.roomTypeGroups) === 'string'
                                                                                        && <p className='error'>{errors.seasons[seasonIndex].tier1.roomTypeGroups}</p>
                                                                                    }
                                                                                </Col>
                                                                                <Col xl={12}>
                                                                                    <table className='table table-striped rates-table'>
                                                                                        <thead>
                                                                                        <tr>
                                                                                            {
                                                                                                this.daysOfWeekLabels.map((dayOfWeek, dayOfWeekIndex) => <th key={`season-${seasonIndex}-${tierLabel}-roomTypeGroup-${roomTypeGroupIndex}-${dayOfWeekIndex}`}>
                                                                                                    {dayOfWeek}
                                                                                                </th>)
                                                                                            }
                                                                                        </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                        <tr key={roomTypeGroupIndex}>
                                                                                            {
                                                                                                this.daysOfWeek.map((dayOfWeek, dayOfWeekIndex) => {
                                                                                                    return <td key={`season-${seasonIndex}-${tierLabel}-roomTypeGroup-${roomTypeGroupIndex}-dayOfWeekRate-${dayOfWeekIndex}`}>
                                                                                                        <TextInput
                                                                                                            id={`season-${seasonIndex}-${tierLabel}-roomTypeGroups-${roomTypeGroupIndex}-rates-${dayOfWeek}-1P`}
                                                                                                            name={`seasons.${seasonIndex}.${tierLabel}.roomTypeGroups.${roomTypeGroupIndex}.rates.${dayOfWeek}.1P`}
                                                                                                            label={FormConst.FIELD_1P}
                                                                                                            type='number'
                                                                                                            min='0.00'
                                                                                                            step='0.25'
                                                                                                            max='2500'
                                                                                                            placeholder='0.00'
                                                                                                            value={
                                                                                                                values.seasons[seasonIndex][tierLabel].roomTypeGroups[roomTypeGroupIndex].rates[dayOfWeek][FormConst.FIELD_1P]
                                                                                                                    = (
                                                                                                                    tierLabel === 'sbase1'
                                                                                                                        ? (values.isSameRateDOW
                                                                                                                                ? values.seasons[seasonIndex].tier1.roomTypeGroups[roomTypeGroupIndex].rates[FormConst.FIELD_MONDAY][FormConst.FIELD_1P]
                                                                                                                                : values.seasons[seasonIndex].tier1.roomTypeGroups[roomTypeGroupIndex].rates[dayOfWeek][FormConst.FIELD_1P]
                                                                                                                        )
                                                                                                                        : (values.isSameRateDOW ? roomTypeGroup.rates[FormConst.FIELD_MONDAY][FormConst.FIELD_1P] : roomTypeGroup.rates[dayOfWeek][FormConst.FIELD_1P])
                                                                                                                )
                                                                                                            }
                                                                                                            disabled={(values.isSameRateDOW && (dayOfWeek !== FormConst.FIELD_MONDAY)) || tierLabel === 'sbase1'}
                                                                                                            title='1 Person Rate' />
                                                                                                        <br />
                                                                                                        <TextInput
                                                                                                            id={`season-${seasonIndex}-${tierLabel}-roomTypeGroups-${roomTypeGroupIndex}-rates-${dayOfWeek}-2P`}
                                                                                                            name={`seasons.${seasonIndex}.${tierLabel}.roomTypeGroups.${roomTypeGroupIndex}.rates.${dayOfWeek}.2P`}
                                                                                                            label={FormConst.FIELD_2P}
                                                                                                            type='number'
                                                                                                            min='0.00'
                                                                                                            step='0.25'
                                                                                                            max='2500'
                                                                                                            placeholder='0.00'
                                                                                                            value={
                                                                                                                values.seasons[seasonIndex][tierLabel].roomTypeGroups[roomTypeGroupIndex].rates[dayOfWeek][FormConst.FIELD_2P]
                                                                                                                    = (tierLabel === 'sbase1'
                                                                                                                        ? (values.isSameRateDOW
                                                                                                                                ? values.seasons[seasonIndex].tier1.roomTypeGroups[roomTypeGroupIndex].rates[FormConst.FIELD_MONDAY][FormConst.FIELD_1P]
                                                                                                                                : values.seasons[seasonIndex].tier1.roomTypeGroups[roomTypeGroupIndex].rates[dayOfWeek][FormConst.FIELD_1P]
                                                                                                                        )
                                                                                                                        : (values.isSameRate1P2P
                                                                                                                            ? (
                                                                                                                                values.isSameRateDOW
                                                                                                                                    ? roomTypeGroup.rates[FormConst.FIELD_MONDAY][FormConst.FIELD_1P]
                                                                                                                                    : roomTypeGroup.rates[dayOfWeek][FormConst.FIELD_1P]
                                                                                                                            )
                                                                                                                            : (
                                                                                                                                values.isSameRateDOW
                                                                                                                                    ? roomTypeGroup.rates[FormConst.FIELD_MONDAY][FormConst.FIELD_2P]
                                                                                                                                    : roomTypeGroup.rates[dayOfWeek][FormConst.FIELD_2P]
                                                                                                                            ))
                                                                                                                )
                                                                                                            }
                                                                                                            disabled={values.isSameRate1P2P || (values.isSameRateDOW && dayOfWeek !== FormConst.FIELD_MONDAY) || tierLabel === 'sbase1'}
                                                                                                            title='2 Person Rate' />
                                                                                                    </td>
                                                                                                })
                                                                                            }
                                                                                        </tr>
                                                                                        </tbody>
                                                                                    </table>
                                                                                </Col>
                                                                                <Col xl={12}>
                                                                                    {
                                                                                        !values.isSameRateAllRoomTypes
                                                                                        && !values.showMultipleTiers
                                                                                        && values.seasons.length === 1
                                                                                        && seasonIndex === 0
                                                                                        && tierLabel === 'tier1'
                                                                                        && values.seasons[0].tier1
                                                                                        && roomTypeGroupIndex === values.seasons[0].tier1.roomTypeGroups.length - 1
                                                                                        && values.seasons[seasonIndex][tierLabel]
                                                                                        && values.seasons[seasonIndex][tierLabel].roomTypeGroups
                                                                                        && values.seasons[seasonIndex][tierLabel].roomTypeGroups.length < this.state.roomTypes.length
                                                                                        && (
                                                                                            <Button
                                                                                                name='Select Room Types'
                                                                                                role='link'
                                                                                                onClick={() => this.splitRoomTypes(values, seasonIndex)} />
                                                                                        )
                                                                                    }
                                                                                </Col>
                                                                            </Row>
                                                                        })
                                                                    }
                                                                    <hr />
                                                                </div>
                                                            }
                                                        </div>
                                                    })
                                                }
                                                {
                                                    this.state.isMultiTier && seasonIndex === 0
                                                    && !values.showMultipleTiers
                                                    && isObjectEmpty(errors)
                                                    && <Button role='link' name={this.state.isLinkedRateplanConfig ? 'Show Linked' : 'More Tiers'} onClick={() => {
                                                        this.addTiers(values)
                                                    }
                                                    } />
                                                }
                                                {
                                                    values.allowSeasons
                                                    && values.isRateSeasonal
                                                    && ((this.state.isMultiTier && values.showMultipleTiers && isObjectEmpty(errors)) || !this.state.isMultiTier)
                                                    && seasonIndex === values.seasons.length - 1
                                                    && (
                                                        <Button name='Add Season' onClick={() => {
                                                            this.addSeason(values)
                                                        }
                                                        }
                                                                disabled={!isObjectEmpty(errors) || isMaxSeasons}
                                                                title={
                                                                    isMaxSeasons
                                                                        ? 'A maximum of 30 seasons allowed'
                                                                        : ''
                                                                }
                                                        />
                                                    )
                                                }
                                            </div>
                                        })
                                    }
                                    {
                                        this.state.isMultiTier
                                        && this.state.isLinkedRateplanConfig
                                        && !values.showMultipleTiers
                                        && <p className='error text-center mt-3'>Please add Linked rateplans to save</p>
                                    }
                                    {
                                        this.state.isMultiTier
                                        && !this.state.isLinkedRateplanConfig
                                        && !values.showMultipleTiers
                                        && <p className='error text-center mt-3'>Please add all tiers to save</p>
                                    }
                                    {
                                        !isObjectEmpty(errors)
                                        &&
                                        <p className='error text-center mt-3'>Please fill in all required fields before saving</p>
                                    }
                                    <FormFooter
                                        form={SideNavEntryMapping.BASE_RATE_PLAN}
                                        isSubmit
                                        submitDisabled={this.state.isMultiTier && !values.showMultipleTiers}
                                        submitName={FormConst.SAVE_BUTTON_TEXT}
                                        noReset />
                                </div>
                                <FormModal
                                    id='rack-rates-page-save-modal'
                                    title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                                    hotelInfo={this.state.hotelInfo}
                                    body={<h6>{this.state.loadingMessage}</h6>}
                                    show={this.state.isLoading}
                                    isLoadingIndicator />
                                <FormModal
                                    id='rack-rates-page-reset-modal'
                                    hotelInfo={this.state.hotelInfo}
                                    title={FormConst.MODAL_RESET_ACTION_TITLE}
                                    body={<h5>{FormConst.MODAL_RESET_ACTION_TEXT}</h5>}
                                    proceed={() => {
                                        this.resetFormData(resetForm)
                                    }}
                                    cancel={() => { this.setState({ showResetModal: false }) }}
                                    show={this.state.showResetModal} />
                                <FormModal
                                    id='rack-rates-page-error-modal'
                                    hotelInfo={this.state.hotelInfo}
                                    title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                                    body={<h5>{this.state.errorMessage}</h5>}
                                    isError
                                    cancel={() => { this.setState({ showErrorModal: false }) }}
                                    show={this.state.showErrorModal} />
                                <FormModal
                                    id='rack-rates-page-edit-modal'
                                    hotelInfo={this.state.hotelInfo}
                                    title={'Edit Rate Options'}
                                    body={<h5>Are you sure you want edit rate options? All rate values will be lost.</h5>}
                                    proceed={() => { this.setState({ isEdit: true, showEditModal: false }) }}
                                    cancel={() => { this.setState({ showEditModal: false }) }}
                                    show={this.state.showEditModal} />
                                <FormModal
                                    id='rack-rates-page-edit-season-modal'
                                    hotelInfo={this.state.hotelInfo}
                                    title={this.state.isLinkedRateplanConfig ? 'Edit BASE rateplan' : 'Edit Tier 1'}
                                    body={<h5>Are you sure you want edit {this.state.isLinkedRateplanConfig ? 'BASE rateplan' : 'Tier 1'}? All other rates will be lost.</h5>}
                                    proceed={() => { this.deleteTiers(values) }}
                                    cancel={() => { this.setState({ showEditTier1Modal: false }) }}
                                    show={this.state.showEditTier1Modal} />
                                <FormModal
                                    id='rack-rates-page-edit-season-modal'
                                    hotelInfo={this.state.hotelInfo}
                                    title={'Edit Season 1'}
                                    body={<h5>Are you sure you want edit Season 1? All other seasons will be lost.</h5>}
                                    proceed={() => { this.deleteSeasons(values) }}
                                    cancel={() => { this.setState({ showEditSeasonModal: false }) }}
                                    show={this.state.showEditSeasonModal} />
                            </Form>
                        )
                    }
                }
            </Formik>
        )
    }
}

// Sample redux dispatch
const mapStateToProps = state => {
    return {
        baseRatePlansResponse: state.reducer.response,
        errorMessage: state.reducer.errorMessage,
        errorDescription: state.reducer.errorDescription,
        count: state.reducer.count
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onPut: (data) => dispatch(asyncMethod(FormConst.FORM_RACK_RATES_NAME, actionTypes.ASYNC_ACTIONS.PUT, data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withFormLayout(RackRateplan, SideNavEntryMapping.BASE_RATE_PLAN))
